import { render, staticRenderFns } from "./BeneficiariesList.vue?vue&type=template&id=e3286a40&"
import script from "./BeneficiariesList.vue?vue&type=script&lang=js&"
export * from "./BeneficiariesList.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiariesList.vue?vue&type=style&index=0&id=e3286a40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports